module.exports = __webpack_public_path__ + "static/image-b9b5c1c3f96260f495a7e6625b47968e.jpg";